<template>
  <div v-if="asyncDataStatus_ready" class="col-full push-top">
    <h2>
      Dodajte novo poslovno enoto:
    </h2>

    <BusinessUnitForm
      @save="save"
      @cancel="cancel"
      :premiseTypes="premiseTypes"
      :childCompanyId="childCompanyId"
    />
  </div>
</template>

<script>
import { mapActions } from 'vuex'
import { saveItem } from '@/utils/crudFunctions'
import BusinessUnitForm from '@/components/BusinessUnitForm'
import asyncDataStatus from '@/mixins/asyncDataStatus'
import { objectToArray } from '@/utils/object'

export default {
  components: {
    BusinessUnitForm
  },
  mixins: [
    asyncDataStatus
  ],
  props: {
    childCompanyId: {
      required: true,
      type: Number
    }
  },
  computed: {
    premiseTypes () {
      return objectToArray(this.$store.state.premiseTypes.items)
    }
  },
  methods: {
    ...mapActions('clientsBusinessUnits', ['saveItem']),
    ...mapActions('premiseTypes', { loadPremiseTypes: 'loadItems' }),
    save ({ data }) {
      saveItem({ childCompanyId: this.childCompanyId, item: data }, 'ClientsBusinessUnits', this)
    },
    cancel () {
      this.$router.push({ name: 'ClientsBusinessUnits' })
    }
  },
  created () {
    this.loadPremiseTypes()
      .then(items => { this.asyncDataStatus_fetched() })
  }
}
</script>
